import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import { statusResolver, STATUS } from '../../main/status';
import DynamicIcon from '../../commons/DynamicIcon';
import { getTimeBetweenDates, useForceUpdate, getLabelStatus } from './helpers';
import Skeleton from '@material-ui/lab/Skeleton';

const styles = (theme) => ({
  root: {
    overflowX: 'auto',
    maxHeight: 88,
    paddingLeft: 1,
    paddingRight: 1,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      overflowX: 'inherit',
      height: 'auto',
      maxHeight: 'inherit'
    }
  },
  content: {
    marginRight: theme.spacing(2),
    width: `calc(100% - ${theme.spacing(2)}px)`,
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '100%',
      zIndex: 111,
      top: 'calc(50% - 1px)',
      width: theme.spacing(2),
      height: 2,
      backgroundColor: grey[400],
      [theme.breakpoints.down('xs')]: {
        top: 'calc(100% - 16px)',
        left: '50%',
        width: 2,
        height: theme.spacing(2),
      }
    },
    '&:last-child': {
      marginRight: theme.spacing(0),
      '&:after': {
        display: 'none'
      }
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginRight: theme.spacing(0),
    },
  },
  itemStatus: {
    width: '100%',
    display: 'block',
    minHeight: 55,
    padding: theme.spacing(1),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: theme.spacing(2),
    }
  },
  current: {
    borderLeft: 4,
    borderColor: 'transparent',
    borderLeftStyle: 'solid',
  },
  text: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block'
  },
  icon: {
    width: 18,
    height: 18,
    marginTop: -3,
    color: grey[600]
  },
  lineHeight: {
    lineHeight: '14px',
  },
  next: {
    backgroundColor: grey[100],
    color: grey[400],
    boxShadow: 'inset 0 1px 3px 0px rgba(0,0,0,.1)'
  },
  iconNext: {
    color: `${grey[400]} !important`
  },
  skeleton: {
    width: '100%',
    display: 'block',
    minHeight: 92,
    marginTop: -16,
  },
});

const getTime = (date, dateNext) => {
  const timeString = getTimeBetweenDates(date, dateNext, true)
  if (timeString === '0s') return '';
  return `Duração: ${timeString}`;
}

function Timeline(props) {
  const { orderStatus, tipoEntrega, loader, theme, classes, orderTimelines, origem } = props;
  const [timelines, setTimelines] = useState([])

  const forceUpdate = useForceUpdate();

  React.useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  });

  const statusFixed = [
    {
      nome: STATUS.CRIADO,
      next: false,
      position: 0
    },
    {
      nome: STATUS.INCLUIDO,
      next: false,
      position: 1
    },
    {
      nome: STATUS.VISUALIZADO,
      next: false,
      position: 2
    },
    {
      nome: STATUS.EM_SEPARACAO,
      next: false,
      position: 3
    },
    {
      nome: STATUS.PRONTO_PARA_SAIR,
      next: false,
      position: 4
    },
    {
      nome: STATUS.SAIU_PARA_ENTREGA,
      next: false,
      position: 5
    },
    {
      nome: STATUS.FINALIZADO,
      next: false,
      position: 6
    }
  ];

  function buildContentStatus() {
    orderTimelines && orderTimelines.forEach((s, i) => {
      if (!(Object.values(STATUS).includes(s.nome))) 
        orderTimelines.splice(i, 1);
    });    
    if (tipoEntrega === 'RETIRADA') 
      statusFixed.splice(5, 1);    
    statusFixed.forEach((itemFixed, index) => {
      if (orderTimelines) {  
        if (!orderTimelines.filter(x => x.nome === itemFixed.nome).length > 0) {
          itemFixed.next = true;
          orderTimelines.push(itemFixed);
        } else {
          orderTimelines.forEach(x => {
            x.current = false;
            if (x.nome === orderStatus) {
              var indexStatusCurrent = orderTimelines.map(s => s.nome).lastIndexOf(orderStatus);
              orderTimelines[indexStatusCurrent].current = true;
            }
            if (x.nome === itemFixed.nome)
              x.position = itemFixed.position;
          });
        }
      }
    });
  }

  if (
    orderStatus !== STATUS.CANCELADO
    && orderStatus !== STATUS.FINALIZADO
    && orderStatus !== STATUS.DEVOLVIDO
    && orderStatus !== STATUS.RETORNAR_PARA_ESTOQUE
    && orderStatus !== STATUS.ENTREGUE
    && orderStatus !== STATUS.RETIRADO
  )
    buildContentStatus()

  const renderSkeleton = (i) => (
    <div key={i} className={classes.content}>
      <Skeleton variant="text" animation="wave" className={classes.skeleton} />
    </div>
  );

  const getDurationString = (item, index) => {
    const ignoreDuration = {
      'PAGO': true,
      'NF_EMITIDA': true,
      'ALTERACAO_CONFIRMADA': true,
      'PREVISTO': true,
    };
    if (item.nome === orderStatus) {
      return getTime(item.data, new Date());
    }
    if (item.nome === 'CRIADO') {
      const next = orderTimelines[index + 1];
      if (next && item.data) {
        return ignoreDuration[next.nome] ? getTime(item.data, new Date()) : getTime(item.data, next.data);
      }
    }
    if (!ignoreDuration[item.nome]) {
      const next = orderTimelines[index + 1];
      if (next && item.data) {
        return ignoreDuration[next.nome] ? getTime(item.data, new Date()) : getTime(item.data, next.data);
      }
    }
    return '';
  }

  useEffect(() => {
    if(orderTimelines){
    setTimelines(orderTimelines.sort(orderTimeline))}
  },[orderTimelines])

  function orderTimeline(a, b){
    if( a.position < b.position)    
        return -1;
    if( a.position > b.position)    
      return 1;
    if( a.data < b.data)    
      return -1;
    if( a.data > b.data)    
      return 1;
    return 0;
  }

  return (
    <Box display="flex" p={1} className={classes.root}>
      {loader && [1, 2, 3, 4, 5].map(renderSkeleton)}
      {!loader && orderTimelines
        && timelines.filter(f => (origem == 'PEGUE_NA_LOJA' && f.nome != 'EM_SEPARACAO') || origem != 'PEGUE_NA_LOJA').map((item, index) => {
          return <Box display="flex" key={index} flexGrow={1} p={0} className={classes.content}>
            <Paper elevation={item.next ? 0 : 1} className={clsx(classes.itemStatus, item.next && classes.next, item.current ? classes.current : '')} style={{ borderColor: theme.palette.pages[statusResolver[item.nome]] }} >
              <Box display="flex">
                <Box width={24} minWidth={24}>
                  <DynamicIcon className={clsx(classes.icon, item.next && classes.iconNext)} icon={statusResolver[item.nome]} style={{ color: theme.palette.pages[statusResolver[item.nome]] }} />
                </Box>
                <Box className={classes.lineHeight}>
                  <Typography variant="subtitle2" className={clsx(classes.text, classes.lineHeight)}>{getLabelStatus[statusResolver[item.nome]]}</Typography>
                  {!item.next && (
                    <Typography variant="caption" className={clsx(classes.text, classes.lineHeight)}>
                      {item.data && new Date(item.data).toLocaleDateString()} {item.data && new Date(item.data).toLocaleTimeString()}
                    </Typography>
                  )}
                  {!item.next &&
                    !([STATUS.FINALIZADO, STATUS.CANCELADO, STATUS.CANCELADO_PELA_LOJA].includes(item.nome)) && (
                      <Typography variant="caption" className={clsx(classes.text, classes.lineHeight)}>
                        {getDurationString(item, index)}
                      </Typography>
                    )
                  }
                </Box>
              </Box>
            </Paper>
          </Box>
        })
      }
    </Box>
  )
}

export default withStyles(styles, { withTheme: true })(Timeline);
